import { JobsDataType } from "../../types/api-response";

interface Props {
  job: JobsDataType;
  checkedData: JobsDataType[];
  setCheckedData: Function;
}

export const selectAllCallBack = ({
  job,
  checkedData,
  setCheckedData,
}: Props) => {
  if ((checkedData?.map(data => data?.jobId))?.includes(job?.jobId)) {
    const newCheckedData = checkedData.filter(
      (singleData) => singleData?.jobId !== job?.jobId
    );
    setCheckedData([...newCheckedData]);
  } else {
    setCheckedData([...checkedData, job]);
  }
};
